import axios from "axios";
// Entities
import { PiecesCde } from "@/entities/index";

export async function getPiecesCde({
  client,
  warehouse,
}: {
  client: string;
  warehouse: string;
}): Promise<{ orderStatus: string[]; currentPiecesStatus: number[] }> {
  const { orderStatus, currentPiecesStatus } = (
    await axios.post(`/api/dashboards/chart5`, {
      client,
      warehouse,
    })
  ).data as PiecesCde;

  return { orderStatus, currentPiecesStatus };
}
